import React, { useState } from 'react'
import OTPInput from 'react-otp-input';

const Forget = ({ tabs, setTabs }) => {
    const [forState, setForState] = useState(1)
    const [otp, setOtp] = useState('');
    const customStyle = {
        width: '50px',
        height: '50px',
        fontSize: '20px',
        borderRadius: '8px',
        border: '1px solid #d9d9d9',
        boxShadow: '0 0 5px rgba(0, 0, 0, 0.1)',
    };

    return (
        <>
            <img src="./assets/svg/logo.svg" alt="" />
            <h2 class="text-2xl font-bold mt-5 text-secondary2">Forgot Password</h2>
            {
                forState === 1 && <p class="mt-2 text-sm text-secondary1">Enter your registered email. We will send you one-time password (OTP) to reset your password</p> ||
                forState === 2 && <p class="mt-2 text-sm text-secondary1">We have sent you one-time password (OTP) to <b className="font-inter font-semibold">name@example.com</b></p>
            }
            {
                forState === 1 &&
                <form class="mt-6">
                    <div className="relative">
                        <div className="w-full">
                            <label class="block text-sm font-medium text-secondary1">Email</label>
                            <input type="email" placeholder="name@example.com" class="w-full mt-1 p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-primary1 focus:border-transparent" />
                        </div>
                    </div>
                </form>
                ||
                forState === 2 &&
                <>
                    <p className='font-inter text-sm text-secondary1 mt-4 mb-4'>Enter OTP</p>
                    <OTPInput
                        inputType='number'
                        value={otp}
                        onChange={setOtp}
                        numInputs={4}
                        renderInput={(props) => <input {...props} />}
                        inputStyle={customStyle}
                        containerStyle={'flex gap-4'}
                    />
                    <p className='font-inter text-sm text-secondary1 mt-4'>Didn’t receive the OTP ? <span className='text-blue'>Resend OTP</span> (5 seconds)</p>

                </>

            }
            {
                forState === 1 && 
                <button onClick={() => setForState(2)} type="submit" class="w-full mt-6 px-4 py-2 text-white bg-primary1 rounded-md hover:bg-primary1 focus:outline-none focus:bg-primary1">
                    Sign in
                </button> 
                ||
                forState === 2 && 
                <button onClick={() => setTabs(3)} type="submit" class="w-full mt-6 px-4 py-2 text-white bg-primary1 rounded-md hover:bg-primary1 focus:outline-none focus:bg-primary1">
                    Verify
                </button> 
            }
            <p class="mt-5 text-sm text-secondary1">Don’t have an account? <span onClick={() => setTabs(1)} class="text-blue hover:underline">Sign up</span></p>
        </>
    )
}

export default Forget